<template>
    <div class="leftGraphics reveal" id="stashe">
        <img 
            class ="deviceTop rellax" 
            src="@/assets/images/device/stashe-phone-top.png" 
            alt="iphone-X-black" 
            data-rellax-speed="1.5" 
            data-rellax-percentage="0.5"/>

        <img 
            class ="deviceBottom rellax" 
            src="@/assets/images/device/stashe-phone-bottom.png" 
            alt="iphone-X-black" 
            data-rellax-speed="-0.5" 
            data-rellax-percentage="0.5"/>
    </div>
</template>

<script>

export default {
  name: 'StasheLeftColumn',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.leftGraphics {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.deviceTop {
    width: 80%;
    margin-left: 10%;
    z-index: 2;
}

.deviceBottom {
    width: 100%;
    margin-top: -50%;
}

</style>



// WEBPACK FOOTER //
// src/components/Apps/Stashe/StasheLeft.vue